<div class="container aim-dialog">
  <router-outlet></router-outlet>

  <div style="text-align: right">
    <img class="powered-by" src="/images/powered_by.png" />
  </div>
</div>
